function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });

        // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

function getInnerHeight(elm) {
    if (typeof (elm) != 'undefined' && elm != null) {
        var computed = getComputedStyle(elm),
            padding = parseInt(computed.paddingTop) + parseInt(computed.paddingBottom);
        return elm.clientHeight - padding
    } else { 
        return "empty element";
    }
}

// demo utility function
function printInnerHeight( selector ){
    console.log(selector + " = " + getInnerHeight(document.querySelector(selector)));
}

function checkElement(screenHeight, sidebarEl) { 
    //console.log('Window height = '+ window.screen.height);
    //printInnerHeight('#boost-sd__filter-tree-wrapper');
    //printInnerHeight('sticky-header');
    if (sidebarEl > screenHeight) { 
        document.querySelector('#boost-sd-filter-tree-column').classList.remove('stickyTop');
        document.querySelector('#boost-sd-filter-tree-column').classList.add('stickyBottom');
    } else { 
        document.querySelector('#boost-sd-filter-tree-column').classList.remove('stickyBottom');
        document.querySelector('#boost-sd-filter-tree-column').classList.add('stickyTop');
    }
}

window.addEventListener('afterRenderHtmlForFilter', function (e) {
    waitForElm('#boost-sd-filter-tree-column').then((elm) => {
        //console.log('element ready');
        var sidebarEl = parseInt(getInnerHeight(document.querySelector('#boost-sd__filter-tree-wrapper')));
        var screenHeight = parseInt(window.screen.height) - parseInt(getInnerHeight(document.querySelector('sticky-header')));
        checkElement(screenHeight, sidebarEl);
    
        // create an Observer instance
        const resizeObserver = new ResizeObserver(entries => {
            //console.log('Body height changed:' + entries[0].target.clientHeight);
            var sidebarEl = parseInt(getInnerHeight(document.querySelector('#boost-sd__filter-tree-wrapper')));
            var screenHeight = parseInt(window.screen.height) - parseInt(getInnerHeight(document.querySelector('sticky-header')));
            checkElement(screenHeight, sidebarEl);
        });
    
        // start observing a DOM node
        resizeObserver.observe(document.querySelector('#boost-sd__filter-tree-wrapper'));
    });
});
